import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  showHomeButton?: boolean;
}

export function ErrorMessage({ message, onRetry, showHomeButton = true }: ErrorMessageProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-80 p-4 text-center">
      <div className="w-16 h-16 mb-6 text-red-500 flex items-center justify-center rounded-full bg-red-50 dark:bg-red-900/20">
        <span className="material-symbols-outlined text-3xl">error</span>
      </div>
      <h2 className="text-xl font-semibold mb-2 text-theme-text dark:text-white">{t('errorMessage.title')}</h2>
      <p className="text-theme-hint mb-6">{message}</p>
      
      <div className="flex flex-wrap gap-3 justify-center">
        {onRetry && (
          <button 
            onClick={onRetry}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
          >
            <span className="material-symbols-outlined text-sm">refresh</span>
            {t('common.retry')}
          </button>
        )}
        
        {showHomeButton && (
          <Link 
            to="/"
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            {t('errorMessage.backToHome')}
          </Link>
        )}
      </div>
    </div>
  );
} 